"use client";

import React from "react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { MapPin, Phone, Mail, Linkedin, Facebook, Twitter, Scale, MessageCircle } from "lucide-react";
function FooterMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <nav className="flex flex-col gap-3">
        <Link to="/" className="text-muted-foreground hover:text-primary transition-colors text-sm">Anasayfa</Link>
        <Link to="/WorkAreasPage" className="text-muted-foreground hover:text-primary transition-colors text-sm">Çalışma Alanları</Link>
        <Link to="/CorporatePage" className="text-muted-foreground hover:text-primary transition-colors text-sm">Kurumsal</Link>
        <Link to="/ArticlesPage" className="text-muted-foreground hover:text-primary transition-colors text-sm">Makaleler</Link>
        <Link to="https://celikhukuk.net/iletisim/" newTab className="text-muted-foreground hover:text-primary transition-colors text-sm">İletişim</Link>
      </nav>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.label === "İletişim" || item.href === "/ContactPage" || item.href === "iletisim/iletisim/" ? "https://celikhukuk.net/iletisim/" : item.href || "#"} newTab={item.label === "İletişim" || item.href === "/ContactPage" || item.href === "iletisim/iletisim/"} className="text-muted-foreground hover:text-primary transition-colors text-sm">
          {item.label}
        </Link>)}
    </nav>;
}
export default function KurumsalAltBilgi() {
  const currentYear = new Date().getFullYear();
  return <footer id="kurumsal-alt-bilgi" className="dark bg-[hsl(222_47%_5%)] text-foreground pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 mb-16">
          
          <div className="lg:col-span-5 flex flex-col gap-8">
            <div className="flex flex-col gap-6">
              <div className="logo-area">
                <Link to="https://celikhukuk.net/">
                  <img src="https://celikhukuk.net/wp-content/uploads/2026/03/LOG-2.jpeg" alt="Av. Arb. Muhammed Çelik Hukuk ve Arabuluculuk Bürosu" className="object-contain self-start opacity-90 !w-[100px] !h-[100px]" />
                </Link>
              </div>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3 text-muted-foreground">
                  <Scale className="w-5 h-5 mt-1 shrink-0 text-primary" />
                  <div className="flex flex-col gap-0.5 text-sm">
                    <p>Av. Arb. Muhammed Çelik</p>
                    <p>Isparta Barosu Sicil No: 651</p>
                    <p>Arabuluculuk Sicil No: 24954</p>
                  </div>
                </div>
                
                <p className="text-muted-foreground text-sm leading-relaxed max-w-md">
                  Av. Arb. Muhammed Çelik Hukuk ve Arabuluculuk Bürosu, 2017'den beri Isparta merkezli olarak hukuki danışmanlık ve avukatlık hizmeti vermektedir. Mesleki etik kurallara ve TBB yönetmeliklerine tam bağlılıkla çalışmaktayız.
                </p>
              </div>

              <div className="flex flex-col gap-4 mt-2">
                <div className="flex items-start gap-3 text-sm text-muted-foreground hover:text-primary transition-colors group">
                  <MapPin className="w-4 h-4 mt-1 shrink-0" />
                  <Link to="https://maps.app.goo.gl/PEBLeJ3gpTdfBbNt5" newTab className="flex-1">
                    Kutlubey Mah. Cengiz Topel Cad. 1006 Sk. No:31/1 Merkez/ISPARTA
                  </Link>
                </div>
                <div className="flex items-start gap-3 text-sm text-muted-foreground hover:text-primary transition-colors group">
                  <Phone className="w-4 h-4 mt-1 shrink-0" />
                  <span className="flex-1">+90 554 842 15 37</span>
                </div>
                <div className="flex items-start gap-3 text-sm text-muted-foreground hover:text-primary transition-colors group">
                  <Mail className="w-4 h-4 mt-1 shrink-0" />
                  <span className="flex-1">av.celik@mail.com</span>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-4 lg:pl-12">
            <h3 className="text-lg font-semibold mb-6 text-foreground tracking-tight">Hızlı Bağlantılar</h3>
            <MenuProvider menu_id="46" className="w-full">
              <FooterMenu />
            </MenuProvider>
          </div>

          <div className="lg:col-span-3">
            <h3 className="text-lg font-semibold mb-6 text-foreground tracking-tight">Sosyal Medya</h3>
            <div className="flex gap-4 mb-8">
              {[{
              icon: Linkedin,
              href: "https://www.linkedin.com/",
              label: "LinkedIn"
            }, {
              icon: Twitter,
              href: "https://x.com/",
              label: "Twitter"
            }, {
              icon: Facebook,
              href: "https://www.facebook.com/",
              label: "Facebook"
            }].map((social, i) => <Link key={i} data-index={i} to={social.href} target="_blank" rel="noopener noreferrer" className="bg-muted/10 p-3 rounded-lg hover:bg-primary hover:text-primary-foreground transition-all duration-300 text-muted-foreground border border-white/5" aria-label={social.label}>
                  <social.icon className="w-5 h-5" />
                </Link>)}
            </div>

            <h3 className="text-lg font-semibold mb-4 text-foreground tracking-tight">Çalışma Saatleri</h3>
            <p className="text-sm text-muted-foreground">
              Pazartesi - Cuma: 09:00 - 18:00
            </p>
            <p className="text-sm text-muted-foreground mt-1">
              Hafta sonu: Kapalı
            </p>
          </div>
        </div>

        <Separator className="bg-border/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-muted-foreground/60 text-center md:text-left">
          <div className="max-w-2xl">
            <p className="mb-2">
              © {currentYear} Av. Arb. Muhammed Çelik Hukuk ve Arabuluculuk Bürosu. Tüm hakları saklıdır.
            </p>
            <p>
              Bu web sitesi, Türkiye Barolar Birliği'nin Meslek Kurallarına ve Reklam Yasağı Yönetmeliği'ne uygun olarak hazırlanmıştır. 
              Sitede yer alan bilgiler hukuki tavsiye niteliğinde değildir ve avukat-müvekkil ilişkisi kurmaz.
            </p>
          </div>
          
          <div className="flex items-center gap-6 shrink-0">
            <Link to="#" className="hover:text-primary transition-colors">Gizlilik Politikası</Link>
            <Link to="#" className="hover:text-primary transition-colors">KVKK Aydınlatma Metni</Link>
          </div>
        </div>
      </div>

      <div className="fixed bottom-4 right-4 z-50">
        <Button asChild className="bg-[#0a192f] text-[#d4af37] border border-[#d4af37] hover:bg-[#0a192f]/90 shadow-xl transition-all duration-300">
          <Link to="https://wa.me/905548421537?text=Merhaba%2C%20hukuki%20bir%20uyu%C5%9Fmazl%C4%B1k%20hakk%C4%B1nda%20size%20dan%C4%B1%C5%9Fmak%20ve%20hukuki%20destek%20almak%20istiyorum.%20M%C3%BCsait%20oldu%C4%9Funuzda%20g%C3%B6r%C3%BC%C5%9Febilir%20miyiz%3F" newTab className="flex items-center gap-2 px-4 py-2">
            <MessageCircle className="w-5 h-5" />
            <span className="font-semibold tracking-wide">WhatsApp</span>
          </Link>
        </Button>
      </div>
    </footer>;
}